import { makeStyles, createStyles, Dialog, DialogContent, DialogActions, Theme, DialogTitle } from '@material-ui/core';
import { LayoutNodeWrapper } from './LayoutNode';
import React, { FC } from 'react';
import { ModalDefinition } from '../services';
import { FormControlProps } from '../utils';

export interface ModalProps extends FormControlProps<ModalDefinition> {};

const useStyles = makeStyles(function(theme: Theme) {
  return createStyles({
    root: {
      flex: 1,
      display: 'flex',
      marginBottom: theme.spacing(2),
      maxWidth: '100%'
    }
  })
});

export const Modal: FC<ModalProps> = function(props) {
  const { definition, path } = props;
  const classes = useStyles({});

  return (
    <div className = { classes.root }>
      <Dialog
        open = { true }
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        { definition.title && <DialogTitle id="alert-dialog-title">
            { definition.title }
          </DialogTitle>
        }
        <DialogContent>
          {
            definition.body && definition.body.children ? definition.body.children.map((_, t) => {
              return <div key = { t }>
                        <LayoutNodeWrapper
                          path = { path.concat('/body/children/') + t }>
                        </LayoutNodeWrapper>
                    </div>
            }) : ''
          }
        </DialogContent>
        <DialogActions>
        {
            definition.actions && definition.actions.children ? definition.actions.children.map((_, t) => {
              return <div key = { t }>
                        <LayoutNodeWrapper
                          path = { path.concat('/actions/children/') + t }>
                        </LayoutNodeWrapper>
                    </div>
            }) : ''
          }
        </DialogActions>
      </Dialog>
    </div>
  )
};
